import "./App.css";
import Home from "./pages/Home";

function App() {
  return (
    <div className="App overflow-x-hidden lg:overflow-x-auto">
      <Home />
    </div>
  );
}

export default App;
